import styles from './Spinner.module.css';

export type SpinnerProps = {
  size?: number;
};

export function Spinner({ size = 20 }: SpinnerProps) {
  return (
    <span
      className={styles['spinner']}
      role="status"
      aria-label="Loading"
      style={{ width: size, height: size }}
    />
  );
}
